import React from 'react';
import SelectField from '../../../forms/SelectField';
import { toSelectionFormat } from '../../../../lib/collection.utils';
import Input from '../../../forms/Input';
import CKPButton from '../../../forms/Button';
import { validateEmail } from '../../../../lib/string.utils';
import Checkbox from '../../../forms/Checkbox';

const ArtistContactForm = ({
    showPerformanceAccess = false,
    contactOptions,
    selectContact,
    newContact,
    showFields,
    data,
    onInput,
    permissionOptions,
    cancelContact,
    submitContact
}) => (
    <div className="ckp-performances-artists-members-form">
        <div className="ckp-performances-artists-members-form-buttons">
            <CKPButton onClick={cancelContact} label="Cancel" className="is-sub is-small" />
            <CKPButton
                inactive={!data.fullName || !data.email || !data.type || !data.permission || !validateEmail(data.email)}
                onClick={submitContact}
                label="Add contact"
                className="is-small"
            />
        </div>

        <SelectField
            onChange={selectContact}
            items={toSelectionFormat(contactOptions)}
            action={newContact}
            actionLabel="Add new contact"
            label="Search contact..."
        />
        {showFields ? (
            <div className="ckp-admin-grid-row">
                <div className="ckp-admin-grid-column">
                    <Input
                        label="Name *"
                        name="fullName"
                        onChange={onInput}
                        value={data.fullName}
                        disabled={!!data.id}
                    />
                </div>
                <div className="ckp-admin-grid-column">
                    <Input
                        label="Email *"
                        name="email"
                        onChange={(e, f) => onInput(e.toLowerCase(), f)}
                        value={data.email}
                        disabled={!!data.id}
                    />
                </div>
                <div className="ckp-admin-grid-column">
                    <SelectField
                        label="Type *"
                        name="type"
                        onChange={onInput}
                        value={data.type}
                        disabled={true}
                        items={[{ label: 'Artist', value: 'artist' }]}
                    />
                </div>
                <div className="ckp-admin-grid-column">
                    <SelectField
                        label="Permission *"
                        name="permission"
                        value={data.permission}
                        onChange={onInput}
                        items={permissionOptions}
                    />
                </div>
                {showPerformanceAccess ? (
                    <div className="ckp-admin-grid-column">
                        <Checkbox
                            className="u-margin-top-2"
                            label="Performance contracts access"
                            name="accessToPerformanceContracts"
                            value={data.accessToPerformanceContracts}
                            onChange={e => onInput(e.target.checked, 'accessToPerformanceContracts')}
                        />
                    </div>
                ) : null}
            </div>
        ) : null}
    </div>
);

export default ArtistContactForm;



// WEBPACK FOOTER //
// ./src/components/admin/forms/contacts/ArtistContactForm.js